<template>
    <app-button-template :text="text" :buttonType="'secondary-black'"></app-button-template>
</template>

<script>
    import AppButtonTemplate from '@/components/ui/buttons/AppButtonTemplate';

    export default {
        name: 'appButtonSecondaryBlack',

        props: ['text'],

        components: {
            AppButtonTemplate
        }
    }
</script>

<style scoped lang="scss">
</style>
